import { StatusPill } from '@/components/ui';
import { resolveVendorApplicationStatus } from '@/lib/domain';

export interface VendorApplicationStatusPillProps {
  status: string | null | undefined;
  displayStatus?: string | null;
  applicationId?: string;
}

export const VendorApplicationStatusPill = ({
  status,
  displayStatus,
  applicationId,
}: VendorApplicationStatusPillProps) => {
  const meta = resolveVendorApplicationStatus(
    status,
    applicationId ? { applicationId } : undefined,
  );
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={status}
      label={displayStatus ?? status ?? '—'}
      testId="vendor-application-status-pill"
    />
  );
};
